import React from 'react';
import { Trans } from 'react-i18next';
import { instanceOf } from 'prop-types';
import { Map } from 'immutable';

import { Link } from '@ets-global/b2c-website-ui';

import Address from '../../../Base/Address';
import { GoogleStaticMap } from '../../../Google';
import LocationTitle from '../../../Base/Title/LocationTitle';

const LocationInfo = ({ session }) => {
  let content = (
    <LocationTitle>
      <Trans>common.online</Trans>
    </LocationTitle>
  );
  if (session.get('testingSite')) {
    const address = session.get('testingSite').get('address');
    const itineraryUrl =
      `https://www.google.com/maps/dir/?` +
      `api=1&` +
      `destination=${encodeURIComponent(
        `${address.getIn(['coordinates', 'latitude'])},${address.getIn(['coordinates', 'longitude'])}`,
      )}`;

    content = (
      <>
        <Address
          addressName={session.get('testingSite').get('name')}
          wheelchairAccess={session.get('testingSite').get('wheelchairAccess')}
          address={address}
        />
        <div className="account-session-detail__place-map">
          <Link to={itineraryUrl} target={'_blank'}>
            <GoogleStaticMap
              coordinates={`${address.getIn(['coordinates', 'latitude'])},${address.getIn([
                'coordinates',
                'longitude',
              ])}`}
              size={{ width: 370, height: 136 }}
            />
          </Link>
        </div>
        <Link to={itineraryUrl} icon={'arrow'} target={'_blank'}>
          <Trans>account.session.detail.location-info.see-itinerary</Trans>
        </Link>
      </>
    );
  }

  return (
    <div className={'account-session-detail__place'}>
      <p className={'account-session-detail-text'}>
        <Trans>account.session.detail.location-info.place-session</Trans>
      </p>
      {content}
    </div>
  );
};

LocationInfo.propTypes = {
  session: instanceOf(Map).isRequired,
};

export default LocationInfo;
